export default __webpack_public_path__ + "static/media/ulucinar3.d587e535.jpg";